import clsx from 'clsx';
import { CSSProperties, FC, useEffect, useMemo, useState } from 'react';

import { Image } from '@/components/molecules/Image';
import { getRandomAppColor } from '@/utils';

interface IProps {
  readonly avatar?: string;
  readonly className?: string;
  readonly imageClassName?: string;
  readonly imageHeight?: number;
  readonly imageStyle?: CSSProperties;
  readonly imageWidth?: number;
  readonly isImageRoundedCircle?: boolean;
  readonly name?: string;
  readonly style?: CSSProperties;
}

const AtDefaultAvatar: FC<IProps> = (props) => {
  const color = useMemo(() => getRandomAppColor(), []);
  // Link avatar hỏng (404 / host chết) cũng phải rơi về ảnh đại diện mặc định
  // thay vì hiển thị ảnh vỡ.
  const [isAvatarBroken, setIsAvatarBroken] = useState(false);

  useEffect(() => setIsAvatarBroken(false), [props.avatar]);

  return (
    <div
      className={clsx('symbol', props.isImageRoundedCircle && 'symbol-circle', props.className)}
      data-testid="at-default-avatar-element"
      style={props.style}
    >
      {(() => {
        if (props.avatar && !isAvatarBroken) {
          return (
            <div className="symbol-label">
              <Image
                alt="avatar"
                className={clsx('border', props.imageClassName)}
                height={props.imageHeight}
                isImageRoundedCircle={props.isImageRoundedCircle}
                onError={() => setIsAvatarBroken(true)}
                src={props.avatar}
                style={props.imageStyle}
                width={props.imageWidth}
              />
            </div>
          );
        }

        return (
          <div className={clsx('symbol-label fs-3', `bg-light-${color}`, `text-${color}`)}>
            {(props.name || '?').charAt(0)}
          </div>
        );
      })()}
    </div>
  );
};

AtDefaultAvatar.defaultProps = { isImageRoundedCircle: true };

export { AtDefaultAvatar };
